import { useLocation } from "react-router-dom";
import { ClientStorage, ClientStorageItem } from "../utils/clientstorage";
import { UserWeddingRole } from "../types/wedding";

export const useEventPlannerPath = () => {
  const location = useLocation();

  const userWeddingRole = ClientStorage.fetch(
    ClientStorageItem.UserWeddingRole
  ) as UserWeddingRole;

  const isEventPlannerPath = location.pathname.startsWith("/wdn/");
  const isEventPlanner =
    userWeddingRole === UserWeddingRole.EventPlanner && isEventPlannerPath;

  const basePath = isEventPlanner ? location.pathname.substring(0, 29) : "";

  return {
    isEventPlanner,
    isEventPlannerPath,
    basePath,
    userWeddingRole,
  };
};
